import { useProductPageContext } from "@/components/ProductPage/context/productPage.context";

import { ECommerce } from "../Product/ECommerce/eCommerce";
import { BrandLogo } from "./components/brandLogo/brandLogo.container";
import { ProductPageProductBundlesContainer } from "./components/bundles/bundles.container";
import { ProductPageImageViewerContainer } from "./components/imageViewer/imageViewer.container";
import { ProductPageFacingContainer } from "./components/productFacing/productFacing.container";
import { ProductInfo } from "./components/productInfo/productInfo.component";
import { PromoBanner } from "./components/promobanner/promoBanner.component";
import { Promotions } from "./components/promotions/promotions.component";
import { RecentlyViewedProductSliderContainer } from "./components/recentlyViewProductsSlider/recentlyViewProductsSlider.container";
import { RecommendProductsSliderContainer } from "./components/recommendProductsSlider/recommendProductsSlider.container";
import { RelatedProductsSlider } from "./components/relatedProductsSlider/relatedProductsSlider.container";
import { ProductPageRepairabilityIndexContainer } from "./components/repairabilityIndex/repairabilityIndex.container";
import { Review } from "./components/review/review";
import { ProductDetailTitleBase } from "./components/title/productDetailTitle.component";
import { RatingSummaryContainer } from "./components/title/ratingSummary/ratingSummary.container";
import { Base } from "./productPage.base";
import { ProductPageProviders } from "./productPage.providers";

const ProductDetailTitle = Object.assign(ProductDetailTitleBase, {
    RatingSummary: RatingSummaryContainer
});

export const ProductPage = Object.assign(Base, {
    useContext: useProductPageContext,
    BrandLogo: BrandLogo,
    ECommerce: ECommerce,
    ImageViewer: ProductPageImageViewerContainer,
    ProductBundles: ProductPageProductBundlesContainer,
    ProductFacing: ProductPageFacingContainer,
    ProductInfo: ProductInfo,
    PromoBanner: PromoBanner,
    Promotions: Promotions,
    Providers: ProductPageProviders,
    RepairabilityIndex: ProductPageRepairabilityIndexContainer,
    Review: Review,
    Title: ProductDetailTitle,
    RecommendProductsSlider: RecommendProductsSliderContainer,
    RelatedProductsSlider: RelatedProductsSlider,
    RecentlyViewedProductSlider: RecentlyViewedProductSliderContainer
});
